import React from 'react';
import { useWindowWidth } from '@react-hook/window-size/throttled';

import Dropdown from './components/Dropdown';
import ShareSocials from '../ShareSocials';
import CopyText from './components/CopyText';

import { socialsWrap } from './styles.module.scss';

const Sources = ({ sources, publicDate, uri, title }) => {
  const windowWidth = useWindowWidth({ initialWidth: 640 });

  return (
    <div className="fluid-container">
      <div className="mt-8 pt-4 border-t border-mine-shaft sm:border-0 sm:mt-8 sm:w-3/4 sm:mx-auto lg:w-full  sm:pt-0 lg:flex lg:justify-between lg:items-start">
        <div className={socialsWrap}>
          <p className={'pb-5 oc-small uppercase'}>share</p>
          <ShareSocials uri={uri} title={title} />
        </div>

        <div className="pt-12 flex-grow relative">
          <div className=" flex-none lg:w-3/4">
            <Dropdown sources={sources} publicDate={publicDate} />

            {windowWidth <= 640 && (
              <div className="mt-7">
                <CopyText publicDate={publicDate} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sources;
